import {
  OMSMetricsRequestSchema,
  SpendByCarrierResponseSchema,
} from "@redotech/redo-fulfillment-common/metrics";

export const getSpendByCarrier = {
  name: "getSpendByCarrier" as const,
  input: OMSMetricsRequestSchema,
  output: SpendByCarrierResponseSchema,
};
